module.exports = __webpack_public_path__ + "static/img/000.0d7b32a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/diy/000.jpg
// module id = vVjf
// module chunks = 15